"use client";
import * as React from "react";
const SvgBackspaceOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.67 0h-10C4.2 0 3.85.23 3.6.59L0 6l3.6 5.4c.25.36.6.6 1.07.6h10c.73 0 1.33-.6 1.33-1.33V1.33C16 .6 15.4 0 14.67 0m0 10.67H4.7L1.6 6l3.1-4.67h9.97zM6.94 9.33l2.4-2.39 2.39 2.4.94-.95L10.27 6l2.4-2.4-.94-.93-2.4 2.39-2.39-2.4-.94.95L8.4 6 6 8.4z" }));
export {
  SvgBackspaceOutlined as default
};
